import React from 'react'
import { SemanticICONS } from 'semantic-ui-react'
import CustomIcon from '~/components/CustomIcon'
import LazyLoadImage from '~/components/LazyLoad'
import { formatFileSize } from '~/utils/helpers'
import { googleDocsTypes, imageTypes, videoTypes } from '~/Constants';
import {
  StyledContentWrapper,
  StyledFileCard,
  StyledFileCheckbox,
  StyledFileDropdown,
  StyledFilePreviewCounter,
  StyledFileSize
} from './style'
import { useTranslation } from 'react-i18next'

interface FileCardProps {
  file: any
  onActionClick: (type: string) => void
  onChecked: (checked, id: string) => void
  checked: boolean,
  disableAction?: boolean
}

const FileCard: React.FC<FileCardProps> = (props) => {
  const { t } = useTranslation()
  const { file, onActionClick, onChecked, checked, disableAction } = props
  const fileNotAbleToPreview = ![...imageTypes, ...videoTypes, ...googleDocsTypes].find(typePreview => typePreview === file?.filetype)

  const dropdownOptions = [
    {
      value: 'edit',
      text: t('Edit'),
      icon: 'pencil',
      disableAction: props.disableAction
    },
    {
      value: 'delete',
      text: t('Delete'),
      icon: 'trash',
      disableAction: props.disableAction
    },
    {
      value: 'download',
      text: t('Download'),
      icon: 'cloud download',
      disableAction: false
    },
    {
      value: 'preview',
      text: t('Preview'),
      icon: 'eye',
      disableAction: fileNotAbleToPreview
    }
  ]

  return <StyledFileCard id={file?.id}>
    {!disableAction && <StyledFileCheckbox
      onChange={(e, data) => onChecked(data.checked, file?.id)}
      checked={checked}
    />
    }
    <StyledFileDropdown
      direction={'left'}
      icon={<CustomIcon name='ellipsis vertical' />}
    >
      <StyledFileDropdown.Menu>
        {dropdownOptions.map(dropdownOption => {
          const { text, value, icon } = dropdownOption
          return !dropdownOption.disableAction && <StyledFileDropdown.Item
            key={value}
            text={text}
            onClick={() => onActionClick(value)}
            value={value}
            icon={<CustomIcon name={icon as SemanticICONS} />}
          />
        })}
      </StyledFileDropdown.Menu>
    </StyledFileDropdown>
    <StyledContentWrapper topMargin={props.disableAction ? '30px' : '10px'}>
      <div className='thumbnailWrapper' onClick={() => onActionClick(fileNotAbleToPreview ? 'download' : 'preview')}>
        <LazyLoadImage
          name={file?.filename}
          id={file?.id}
          apiUrl={`/cloud-storage/files/${file?.id}/get-file-url`}
          type={file?.filetype}
        />
      </div>
    </StyledContentWrapper>
    <div className='name'>{file?.title}</div>
    <StyledFilePreviewCounter>
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        <CustomIcon style={{ cursor: 'default' }} name='eye' />
        <div>{file?.views}</div>
      </div>
    </StyledFilePreviewCounter>
    <StyledFileSize>
      {formatFileSize(file?.filesize)}
    </StyledFileSize>
  </StyledFileCard>

}
export default FileCard